<template>
  <v-menu open-on-hover bottom max-height="300px">
    <template v-slot:activator="{ on }">
      <v-btn :color="color"
             dark
             v-on="on">
        {{ $t('general.copyCustomizedField') }}
        <v-icon class="ml-2">mdi-file-multiple-outline</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item color="kbDarkBlue"
                   v-for="(item, index) in customizationItems"
                   :key="index"
                   @click="copyCustomizedField(item.value)">
        <v-list-item-title>{{ item.label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
export default {
  computed: {
    ...mapState({
      appCustomExtradatas: state => state.apps.appCustomExtradatas
    }),
    customizationItems () {
      const nameValue = this.$route.name === 'Disparadores' ? '{{NAME}}' : '{{name}}'
      let customExtradataFields = []
      if (this.appCustomExtradatas &&
          Array.isArray(this.appCustomExtradatas) &&
          this.appCustomExtradatas.length) {
        customExtradataFields = this.appCustomExtradatas.map(extraData => {
          if (typeof extraData.name === 'string' && extraData.name.split(' ').length > 1) {
            return { label: extraData.name, value: `{{[${extraData.name}]}}` }
          } else {
            return { label: extraData.name, value: `{{${extraData.name}}}` }
          }
        })
      }
      return [
        { label: this.$t('general.name'), value: nameValue },
        { label: this.$t('general.phone'), value: '{{phone}}' },
        { label: this.$t('general.email'), value: '{{email}}' },
        ...customExtradataFields
      ]
    }
  },
  created () {
    this.getAppCustomExtradatas()
  },
  data () {
    return {
    }
  },
  methods: {
    copyCustomizedField (customizedField) {
      if (!navigator.clipboard) {
        notifications.error(this.$t('general.couldNotCopyFieldToClipboard'))
        return
      }
      const vue = this
      navigator.clipboard.writeText(customizedField).then(function () {
        notifications.success(vue.$t('general.customFieldSuccessfullyCopiedToClipboard'))
      }, function () {
        notifications.error(vue.$t('general.couldNotCopyFieldToClipboard'))
      })
    },
    async getAppCustomExtradatas () {
      try {
        await this.$store.dispatch('getAppCustomExtradatas')
      } catch (e) {
        notifications.error(e)
      }
    }
  },
  props: {
    color: {
      type: String,
      default: 'mainButtons'
    }
  }
}
</script>
